import { gql } from '@apollo/client';

export default gql`
  mutation remindPassword($email: String!) {
    remindPassword(input: { email: $email }) {
      success
    }
  }
`;
